import { Snackbar } from "@material-ui/core";
import { useEffect, useState } from "react";
import { Alert } from "@material-ui/lab";
import { useNavigate } from "react-router-dom";
import ProductionOrderService from "../../../../../services/Production/ProductionOrderService";
import getCurrentUserId from "../../../../../reduxSaga/sagas/requests/currentUserId";
import UtilsFormule from "../../../../../utils/UtilsFormule";
import withLoader from "../../../../../components/layouts/WithLoader";
import DataTableProductionOrder from "./DataTableProductionOrder";

const ProductionOrderList = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const [availableBOM, setAvailableBOM] = useState([]);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const onAddWorkStationHandler = () => {
    navigate(`/production-orders/new`);
  };

  useEffect(() => {
    startLoading();
    ProductionOrderService.getAllPO(getCurrentUserId())
      .then((response) => {
        console.log("response", response);
        if (response.data.success) {
          setAvailableBOM(response.data.success);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de nomenclature");
        }
      })
      .catch((e) => {
        console.log("error", e);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card  mt-3">
                <div class="card-body">
                  <h5 class="card-title">Les Ordres de production</h5>
                  <button
                    class="btn btn-dark float-right"
                    data-toggle="modal"
                    data-target="#add-brand"
                    onClick={onAddWorkStationHandler}
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
              </div>
              {availableBOM && (
                <DataTableProductionOrder listProductionOrder={availableBOM} />
              )}
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(ProductionOrderList);
